import { QueryClient } from '@tanstack/react-query';

// Default config: dados estáticos (stores, models, operatingHours) usam staleTime de 5 min.
// Polling agressivo (15s) é configurado APENAS nos hooks que precisam (useAvailability).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 2,
      retryDelay: 1000,
    },
  },
});

export const queryKeys = {
  stores: ['stores'] as const,
  store: (id: string) => ['stores', id] as const,

  appointments: (params?: { storeId?: string; date?: string }) =>
    ['appointments', params] as const,
  appointment: (id: string) => ['appointments', 'detail', id] as const,

  operatingHours: (storeId: string) => ['operatingHours', storeId] as const,
  specialDateHours: (storeId: string) => ['specialDateHours', storeId] as const,

  availability: (storeId: string, date: string, time: string) =>
    ['availability', storeId, date, time] as const,
};
